import React, { useRef, useState, useImperativeHandle, forwardRef } from 'react';

const Recorder = forwardRef(({ startTime, endTime, onRecordingComplete, videoRef, setRecording, loopCount }, ref) => {
  const [recording, setRecordingState] = useState(false);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);

  useImperativeHandle(ref, () => ({
    stopRecording: () => {
      if (mediaRecorderRef.current && recording) {
        mediaRecorderRef.current.stop();
        setRecording(false);
      }
    }
  }));

  const startRecording = () => {
    navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
      const mediaRecorder = new MediaRecorder(stream);
      mediaRecorderRef.current = mediaRecorder;
      audioChunksRef.current = [];
      mediaRecorder.start();
      setRecording(true);
      setRecordingState(true);

      mediaRecorder.ondataavailable = (e) => {
        audioChunksRef.current.push(e.data);
      };

      mediaRecorder.onstop = () => {
        const combinedBlob = new Blob(audioChunksRef.current, { type: 'audio/wav' });
        const audioURL = URL.createObjectURL(combinedBlob);
        onRecordingComplete(audioURL);
        setRecording(false);
        setRecordingState(false);
      };

      let loopCounter = 0;
      const recordSegment = () => {
        if (videoRef.current) {
          videoRef.current.seekTo(startTime);
          videoRef.current.playVideo();
        }

        setTimeout(() => {
          if (mediaRecorder.state === 'recording') {
            if (videoRef.current) {
              videoRef.current.pauseVideo();
            }
            loopCounter++;
            if (loopCounter < loopCount) {
              recordSegment();
            } else {
              mediaRecorder.stop();
              setRecording(false);
            }
          }
        }, (endTime - startTime) * 1000);
      };

      recordSegment();
    }).catch(error => {
      console.error("Error accessing media devices:", error);
      alert("Unable to access the microphone. Please check your browser permissions and try again.");
    });
  };

  return (
    <button onClick={startRecording} disabled={recording}>
      {recording ? 'Enregistrement en cours...' : 'Commencer l\'enregistrement'}
    </button>
  );
});

export default Recorder;
